'use client'

import { useState } from 'react'
import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUIButton from '@mui/material/Button'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { useCOISStore } from '@repo/store/useCOISStore'
import { AddIcon } from '@repo/ui/AddIcon'
import { CustomDataPageSelectionRow } from '@repo/ui/CustomDataPageSelectionRow'
import { useTheme } from '@mui/material/styles'

const getNewEntry = () => {
  return {
    customDataPageFieldComparison: { id: Date.now() },
    customDataComparisonBooleanOperator: 0
  }
}

export const COISRefineYourSearch = ({ wideMode, handlePrevNext }) => {
  const theme = useTheme()
  const { currentPartyId, updateParty, parties, updateCOISWizardSidebar } = useCOISStore()
  const defaultValue = parties[currentPartyId]?.customDataPageFieldClauses || [getNewEntry()]
  const [customDataPageFieldClauses, setCustomDataPageFieldClauses] = useState(defaultValue)
  if (!currentPartyId) return null

  const addClause = () => {
    setCustomDataPageFieldClauses([...customDataPageFieldClauses, getNewEntry()])
  }

  const removeClause = (id) => {
    const updatedClauses = customDataPageFieldClauses.filter((clause) => clause.customDataPageFieldComparison.id !== id)
    setCustomDataPageFieldClauses(updatedClauses)
  }

  const handleSelection = (updatedComparison, comparisonOperator) => {
    const tempState = [...customDataPageFieldClauses]

    const clauseIndex = customDataPageFieldClauses.findIndex(
      (clause) => clause.customDataPageFieldComparison.id === updatedComparison.id
    )
    if (clauseIndex || clauseIndex === 0) {
      tempState[clauseIndex].customDataPageFieldComparison = updatedComparison
      tempState[clauseIndex].customDataComparisonBooleanOperator = comparisonOperator
    }
    setCustomDataPageFieldClauses(tempState)
  }

  const handleClickContinue = () => {
    updateParty({
      partyId: currentPartyId,
      newFieldKey: 'customDataPageFieldClauses',
      newFieldValue: customDataPageFieldClauses
    })

    updateCOISWizardSidebar()
    handlePrevNext(1)
  }

  const handleClickBack = () => {
    updateCOISWizardSidebar()
    handlePrevNext(-1)
  }

  return (
    <>
      <MUIStack data-testid="COISRefineYourSearch" direction="column" gap={3}>
        {customDataPageFieldClauses.map((clause, index) => (
          <CustomDataPageSelectionRow
            comparison={clause.customDataPageFieldComparison}
            comparisonOperatorDefault={clause.customDataComparisonBooleanOperator}
            removeClause={removeClause}
            key={clause?.customDataPageFieldComparison?.id || index}
            onSelection={handleSelection}
            isLast={index === customDataPageFieldClauses.length - 1}
          />
        ))}
      </MUIStack>

      <MUIButton
        sx={{ mt: 4, textTransform: 'none', color: 'secondary.main' }}
        onClick={addClause}
        startIcon={<AddIcon sx={{ width: '24px', height: '24px', color: theme?.palette?.secondary?.dark || 'blue' }} />}
      >
        Add new
      </MUIButton>
      <WizardFooter wideMode={wideMode} handleClickContinue={handleClickContinue} handleClickBack={handleClickBack} />
    </>
  )
}

COISRefineYourSearch.propTypes = {
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func
}
